import { render, staticRenderFns } from "./Finish24startNewProject.vue?vue&type=template&id=7b3a052b&scoped=true&"
import script from "./Finish24startNewProject.vue?vue&type=script&lang=js&"
export * from "./Finish24startNewProject.vue?vue&type=script&lang=js&"
import style0 from "./Finish24startNewProject.vue?vue&type=style&index=0&id=7b3a052b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3a052b",
  null
  
)

export default component.exports